export const destroy = (self) => {
  if (self._canvas_el != null) {
    self._container_el?.removeChild(self._canvas_el);
  }
  self._container_el = null;
  self._canvas_el = null;
  self._layers_el = null;
  self._art_board_layer_el = null;
  self._background_layer_el = null;
  self._target_image_layer_el = null;
  self._foreground_layer_el = null;
  self._clip_path_layer_el = null;
  self._empty_grid_layer_el = null;
  self._existing_grid_layer_el = null;
  self._selector_grid_layer_el = null;
  self._copy_source_grid_layer_el = null;
  self._copy_destination_unselected_empty_grid_layer_el = null;
  self._copy_destination_unselected_existing_grid_layer_el = null;
  self._copy_destination_selected_grid_layer_el = null;
  self._art_board_rect_el = null;
  self._art_board_filter_drop_shadow_el = null;
  self._background_base_el = null;
  self._background_color_el = null;
  self._background_image_el = null;
  self._clip_path_el = null;
  self._view_port = null;
  self._view_box = null;
  self._art_board = null;
  self._background = null;
  self._grids = new Map();
  self._selected_grid_id = null;
  self._copy_source_grid_id = null;
};
